import { Injectable } from '@angular/core';

@Injectable()
export class LoadService {

  private loadedScripts: { [id: string]: boolean } = {};

  addScripts(scriptData: { id: string, url: string }[]): Promise<void> {
    const promises: Promise<void>[] = [];
    scriptData.forEach(data => {
      promises.push(this.loadScript(data.id, data.url));
    });
    return Promise.all(promises).then(() => {});
  }

  removeScripts(scriptIds: string[]): Promise<void> {
    const promises: Promise<void>[] = [];
    scriptIds.forEach(id => {
      promises.push(this.removeScript(id));
    });
    return Promise.all(promises).then(() => {});
  }

  private loadScript(id: string, url: string): Promise<void> {
    return new Promise((resolve, reject) => {
      if (this.loadedScripts[id]) {
        resolve();
        return;
      }

      const script = document.createElement('script');
      script.type = 'text/javascript';
      script.src = url;
      script.id = id;
      script.onload = () => {
        this.loadedScripts[id] = true;
        resolve();
      };
      script.onerror = (error) => {
        reject(error);
      };
      document.head.appendChild(script);
    });
  }

  private removeScript(id: string): Promise<void> {
    return new Promise((resolve, reject) => {
      const script = document.getElementById(id);
      if (script) {
        script?.parentNode?.removeChild(script);
        delete this.loadedScripts[id];
        resolve();
      } else {
        reject(`Script with ID ${id} not found.`);
      }
    });
  }

  // 4th solution
  // private loadedScripts: { [id: string]: boolean } = {};

  // addScripts(scriptData: { id: string, url: string }[]): void {
  //   scriptData.forEach(data => {
  //     this.loadScript(data.id, data.url);
  //   });
  // }

  // removeScripts(scriptIds: string[]): void {
  //   scriptIds.forEach(id => {
  //     const script = document.getElementById(id);
  //     if (script) {
  //       script?.parentNode?.removeChild(script);
  //       delete this.loadedScripts[id];
  //     }
  //   });
  // }

  // private loadScript(id: string, url: string): void {
  //   // if (this.loadedScripts[id]) {
  //   //   return;
  //   // }

  //   const script = document.createElement('script');
  //   script.type = 'text/javascript';
  //   script.src = url;
  //   script.id = id;
  //   script.onload = () => {
  //     this.loadedScripts[id] = true;
  //   };
  //   script.onerror = (error) => {
  //     console.error('Script loading failed:', error);
  //   };
  //   document.head.appendChild(script);
  // }

  // 3rd solution
  // private loadedScripts: { [id: string]: boolean } = {};

  // loadScriptsOnce(scriptData: { id: string, url: string }[]): void {
  //   scriptData.forEach(data => {
  //     if (!this.loadedScripts[data.id]) {
  //       this.loadScript(data.id, data.url);
  //     }
  //   });
  // }

  // private loadScript(id: string, url: string): void {
  //   if (this.loadedScripts[id]) {
  //     return; // Already loaded, no need to load again
  //   }

  //   const script = document.createElement('script');
  //   script.type = 'text/javascript';
  //   script.src = url;
  //   script.id = id; // Set the id attribute
  //   script.onload = () => {
  //     this.loadedScripts[id] = true;
  //   };
  //   script.onerror = (error) => {
  //     console.error('Script loading failed:', error);
  //   };
  //   document.head.appendChild(script);
  // }

  // 2nd solution
  // public loadedScripts: { [id: string]: boolean } = {};

  // loadScriptsOnce(scriptData: { id: string, url: string }[]): Promise<void[]> {
  //   const promises: Promise<void>[] = [];
  //   scriptData.forEach(data => {
  //     if (!this.loadedScripts[data.id]) {
  //       promises.push(this.loadScript(data.id, data.url));
  //     }
  //   });
  //   return Promise.all(promises);
  // }

  // private loadScript(id: string, url: string): Promise<void> {
  //   return new Promise((resolve, reject) => {
  //     const script = document.createElement('script');
  //     script.type = 'text/javascript';
  //     script.src = url;
  //     script.id = id;
  //     script.onload = () => {
  //       this.loadedScripts[id] = true;
  //       resolve();
  //     };
  //     script.onerror = (error) => {
  //       reject(error);
  //     };
  //     document.head.appendChild(script);
  //   });
  // }

  // 1st solution
  // private static loadedScripts: { [url: string]: boolean } = {};

  // // eslint-disable-next-line @typescript-eslint/no-explicit-any
  // loadScripts(urls: string[]): Promise<any[]> {
  //   const loadPromises = urls.map(url => this.loadScript(url));
  //   return Promise.all(loadPromises);
  // }

  // // eslint-disable-next-line @typescript-eslint/no-explicit-any
  // private loadScript(url: string): Promise<any> {
  //   return new Promise((resolve, reject) => {
  //     const script = document.createElement('script');
  //     script.type = 'text/javascript';
  //     script.src = url;
  //     script.onload = resolve;
  //     script.onerror = reject;
  //     document.head.appendChild(script);
  //   });
  // }
}
